import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=6a5b262a&"
import script from "./GenericCard.vue?vue&type=script&lang=ts&"
export * from "./GenericCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports